/* tslint:disable */
/* eslint-disable */
export enum BudgetLimitEnum {
  FROM_5_TO_25_K = 'From_5_to_25K',
  FROM_25_TO_50_K = 'From_25_to_50K',
  FROM_50_TO_100_K = 'From_50_to_100K',
  FROM_100_TO_250_K = 'From_100_to_250K',
  FROM_250_TO_500_K = 'From_250_to_500K',
  FROM_500_K_TO_1_M = 'From_500K_to_1M',
  MORE_THAN_1_M = 'MoreThan1M'
}
